module.exports = __webpack_public_path__ + "img/Folded_Paper_Werk_Thanks.5412778d.jpg";